import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import styles from './Badge.module.css';

export const Badge = ({
  variant = 'success',
  ...props
}: {
  variant?: 'secondary' | 'success' | 'information' | 'danger';
} & PropsWithChildren) => (
  <div
    className={clsx(
      styles.badge,
      variant === 'success' && styles.success,
      variant === 'information' && styles.information,
      variant === 'secondary' && styles.secondary,
    )}
    {...props}
  />
);
